import { Injectable } from '@angular/core';
import { ColGroupDef } from 'ag-grid-enterprise';
import { DropdownListRenderer } from 'src/app/shared/renderers/dropdown-list/dropdown-list.component';
import { InputTextRenderer } from 'src/app/shared/renderers/input-text/input-text.component';
import { Constants } from 'src/app/shared/utils/constants';
import { HHRAConstants } from '../../hhra-constants';
import { DuplicateButtonRenderer } from 'src/app/shared/renderers/duplicate-button/duplicate-button.component';
import { InputTextApplicationSchemeRenderer } from 'src/app/shared/renderers/input-text/input-text-application-scheme/input-text-application-scheme.component';

@Injectable({
    providedIn: 'root',
})

export class PPESGranulesColdef {

    public getColumnsDefinition(isProjectOwnershipValid: boolean): any[] {
        return [
            {
                headerName: '',
                children: [
                    {
                        headerName: '',
                        field: 'select',
                        type: 'default',
                        headerCheckboxSelection: isProjectOwnershipValid,
                        checkboxSelection: true,
                        width: 50,
                        hide: false,
                        editable: false,
                        pinned: 'left',
                        cellStyle: () => {
                        return !isProjectOwnershipValid ? { pointerEvents: 'none', backgroundColor: '#f0f0f0'}
                            : undefined;
                        }
                    },
                    {
                        headerName: 'PPE Scheme',
                        field: 'name',
                        minWidth: 380,
                        width: 380,
                        type: 'default',
                        filter: true,
                        cellRenderer: InputTextApplicationSchemeRenderer,
                        cellRendererParams: {
                          isRequired: true,
                          disabled: !isProjectOwnershipValid
                        },
                        pinned: 'left',
                    }
                ]
            },
            {
                headerName: 'PPE - Mixing and loading',
                children: [

                    {
                        headerName: 'Gloves',
                        field: 'mixingLoadingGloves',
                        type: 'default',
                        filter: 'agSetColumnFilter',
                        cellRenderer: DropdownListRenderer,
                        cellRendererParams: {
                            options: HHRAConstants.HHRA_PPES_GLOVES_GRANULES,
                            optionLabel: 'name',
                            optionValue: 'value',
                            disabled: !isProjectOwnershipValid,
                        },
                        wrapText: true,
                        resizable: true,
                        sortable: true,
                        width: 195,
                        minWidth: 195,
                        editable: false,
                    },
                    {
                        headerName: 'Body PPE',
                        field: 'mixingLoadingBody',
                        type: 'default',
                        filter: 'agSetColumnFilter',
                        cellRenderer: DropdownListRenderer,
                        cellRendererParams: {
                            options: HHRAConstants.HHRA_PPES_BODY,
                            optionValue: 'name',
                            optionLabel: 'name',
                            disabled: !isProjectOwnershipValid,
                        },
                        wrapText: true,
                        resizable: true,
                        sortable: true,
                        width: 200,
                        minWidth: 200,
                        editable: false,
                    },
                    {
                        headerName: 'RPE',
                        field: 'mixingLoadingRPE',
                        type: 'default',
                        filter: 'agSetColumnFilter',
                        cellRenderer: DropdownListRenderer,
                        cellRendererParams: {
                            options: HHRAConstants.HHRA_PPES_RPE,
                            optionValue: 'name',
                            optionLabel: 'name',
                            disabled: !isProjectOwnershipValid,
                        },
                        wrapText: true,
                        resizable: true,
                        sortable: true,
                        width: 120,
                        minWidth: 120,
                        editable: false,
                    },

                ]
            },
            {
                headerName: 'PPE - Application',
                children: [

                    {
                        headerName: 'Gloves',
                        field: 'applicationGloves',
                        type: 'default',
                        filter: 'agSetColumnFilter',
                        cellRenderer: DropdownListRenderer,
                        cellRendererParams: {
                            options: HHRAConstants.HHRA_PPES_GLOVES_GRANULES,
                            optionLabel: 'name',
                            optionValue: 'value',
                            disabled: !isProjectOwnershipValid,
                        },
                        wrapText: true,
                        resizable: true,
                        sortable: true,
                        width: 195,
                        minWidth: 195,
                        editable: false,
                    },
                    {
                        headerName: 'Body PPE',
                        field: 'applicationBody',
                        type: 'default',
                        filter: 'agSetColumnFilter',
                        cellRenderer: DropdownListRenderer,
                        cellRendererParams: {
                            options: HHRAConstants.HHRA_PPES_BODY,
                            optionValue: 'name',
                            optionLabel: 'name',
                            disabled: !isProjectOwnershipValid,
                        },
                        wrapText: true,
                        resizable: true,
                        sortable: true,
                        width: 200,
                        minWidth: 200,
                        editable: false,
                    },
                    {
                        headerName: 'RPE',
                        field: 'applicationRPE',
                        type: 'default',
                        filter: 'agSetColumnFilter',
                        cellRenderer: DropdownListRenderer,
                        cellRendererParams: {
                            options: HHRAConstants.HHRA_PPES_RPE,
                            optionValue: 'name',
                            optionLabel: 'name',
                            disabled: !isProjectOwnershipValid,
                        },
                        wrapText: true,
                        resizable: true,
                        sortable: true,
                        width: 120,
                        minWidth: 120,
                        editable: false,
                    },
                   {
                        headerName: '',
                        colId: 'duplicate',
                        field: 'duplicateButton',
                        cellRenderer: DuplicateButtonRenderer,
                        type: 'rightAligned',
                        width: 130,
                        cellRendererParams: {
                            disabled: !isProjectOwnershipValid,
                            mainTablePkName: "personalProtectionEquipmentSchemePK"
                        }        
                    },                        
                    {
                        colId: 'action',
                        width: 125,
                        minWidth: 125,
                        editable: false,
                        cellRenderer: 'deleteButtonRenderer',
                        cellRendererParams: {
                          disabled: !isProjectOwnershipValid
                        },
                        type: 'rightAligned'
                    }
                ]
            }
        ];
    }
}
